import constants from 'config/constants'

const isRunningInIframe = () => {
  try {
    return window.self !== window.top
  } catch {
    return true
  }
}

export const initializeOAuthFlow = (customRedirectURI, oauthProvider) => {
  const OAuthURL = `https://api.workos.com/user_management/authorize?client_id=${constants.workOsClientId}&`

  if (customRedirectURI) {
    const redirectURI = `${encodeURIComponent(
      customRedirectURI
    )}&response_type=code&provider=${oauthProvider}`
    const link = `${OAuthURL}redirect_uri=${redirectURI}`
    window.open(link, '_blank')
  } else {
    const defaultRedirectURI = `${encodeURIComponent(
      window.location.origin + '/signup/complete-sso-signup/'
    )}&response_type=code&provider=${oauthProvider}`
    const link = `${OAuthURL}redirect_uri=${defaultRedirectURI}`
    if (isRunningInIframe()) {
      window.open(link, '_blank')
    } else {
      location.href = link
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/containers/SignUpFormV2/utils.js